import React, { useEffect, useState } from "react";

import axios from "axios";
import { getCurrentDate, getCurrentMonthFirstDate } from "../../../Utilitie";
import HandOverDayWise from "./TableView/HandOverDayWise";
import TakenOverDayWise from "./TableView/TakenOverDayWise";
import LongHaulController from "./LongHaulController";
import LongHaulToController from "./LongHaulToController";
import MonthWiseHoGraph from "./GraphView/MonthWiseHoGraph";
import MonthWiseToGraph from "./GraphView/MonthWiseToGraph";
import CountDayWise from "./TableView/CountDayWise";

const opState = { Month: false, Date: false, Ex: false, TpSp: false };
const opState1 = { Month: false, Date: false, Ex: false, TpSp: false };
const urlPrefix = process.env.REACT_APP_URL_PREFIX;
const LonghaulMaster = ({}) => {
  const [active, setActive] = useState("HandOver");
  const [filteredData, setFilteredData] = useState(null);
  const [openStates, setOpenStates] = useState(opState);
  const [selectedFilters, setSelectedFilters] = useState(null);
  const [filteredData1, setFilteredData1] = useState(null);
  const [selectedFilters1, setSelectedFilters1] = useState(null);
  const [openStates1, setOpenStates1] = useState(opState1);

  const [startDate, setStartDate] = useState(getCurrentMonthFirstDate());
  const [endDate, setEndDate] = useState(getCurrentDate());

  const [handOverData, setHandOverData] = useState([]);
  const [takenOverData, setTakenOverData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${urlPrefix}longhaul-handover?from=${startDate}&to=${endDate}`,
      );
      if (response.data.status === "ok") {
        setHandOverData(response.data.data);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch stations:", error);
      setLoading(false);
      setError(true);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  /////////////////////////////////////
  const fetchData2 = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${urlPrefix}longhaul-takenover?from=${startDate}&to=${endDate}`,
      );
      if (response.data.status === "ok") {
        setTakenOverData(response.data.data);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch stations:", error);
      setLoading(false);
      setError(true);
    }
  };
  useEffect(() => {
    fetchData2();
  }, []);
  /////////////////////////////////////

  return (
    <div>
      <div
        className="papaDiv"
        onClick={() => {
          setOpenStates1(opState1);
          setOpenStates(opState);
        }}
      >
        <h5 className="text-center bg-dark text-white p-1 m-1">
          Filter by Date
        </h5>
        <div className="bg-dark">
          <div className="d-flex  justify-content-end align-items-center me-2">
            <b>From </b>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="me-1"
              max={getCurrentDate()}
            />

            <b>To </b>
            <input
              type="date"
              value={endDate}
              max={getCurrentDate()}
              onChange={(e) => setEndDate(e.target.value)}
            />
            <button
              className="ms-1 btn btn-sm btn-outline-light"
              onClick={() => {
                fetchData();
                fetchData2();
              }}
            >
              Fetch
            </button>
          </div>
        </div>
        {/* ////////////////////////////// */}

        <div className="row ">
          <div className="d-flex justify-content-center m-2">
            <button
              onClick={() => {
                setActive("HandOver");
              }}
              className={`btn btn-sm btn-outline-dark me-1 ${
                active === "HandOver" && "active"
              }`}
            >
              Hand Over
            </button>
            <button
              onClick={() => {
                setActive("TakenOver");
              }}
              className={`btn btn btn-outline-dark ms-1 ${
                active === "TakenOver" && "active"
              }`}
            >
              Taken Over
            </button>
          </div>
        </div>

        <div className="row">
          {active === "HandOver" ? (
            <div className="col-md-12">
              <div className="sticky-controller">
                <LongHaulController
                  data={handOverData}
                  setSelectedFilters={setSelectedFilters}
                  setFilteredData={setFilteredData}
                  openStates={openStates}
                  setOpenStates={setOpenStates}
                />
              </div>{" "}
              <div
                onClick={() => {
                  setOpenStates1(opState1);
                  setOpenStates(opState);
                }}
              >
                <MonthWiseHoGraph
                  data={filteredData}
                  date={{ start: startDate, end: endDate }}
                />
              </div>{" "}
              <div className="d-flex row">
                <div
                  className="col-10"
                  onClick={() => {
                    setOpenStates1(opState1);
                    setOpenStates(opState);
                  }}
                >
                  <HandOverDayWise
                    data={filteredData}
                    date={{ start: startDate, end: endDate }}
                  />
                </div>{" "}
                <div
                  className="col-2"
                  onClick={() => {
                    setOpenStates1(opState1);
                    setOpenStates(opState);
                  }}
                >
                  <CountDayWise
                    data={filteredData}
                    date={{ start: startDate, end: endDate }}
                  />
                </div>
              </div>{" "}
            </div>
          ) : (
            <div className="col-md-12">
              <div className="sticky-controller">
                <LongHaulController
                  data={takenOverData}
                  setSelectedFilters={setSelectedFilters1}
                  setFilteredData={setFilteredData1}
                  openStates={openStates}
                  setOpenStates={setOpenStates}
                />
              </div>
              <div
                className="col-md-12"
                onClick={() => {
                  setOpenStates1(opState1);
                  setOpenStates(opState);
                }}
              >
                <MonthWiseToGraph
                  data={filteredData1}
                  date={{ start: startDate, end: endDate }}
                />
              </div>
              <div className="d-flex row">
                <div
                  className="col-10"
                  onClick={() => {
                    setOpenStates1(opState1);
                    setOpenStates(opState);
                  }}
                >
                  <TakenOverDayWise
                    data={filteredData1}
                    date={{ start: startDate, end: endDate }}
                  />
                </div>{" "}
                <div
                  className="col-2"
                  onClick={() => {
                    setOpenStates1(opState1);
                    setOpenStates(opState);
                  }}
                >
                  <CountDayWise
                    data={filteredData1}
                    date={{ start: startDate, end: endDate }}
                  />
                </div>
              </div>{" "}
            </div>
          )}
        </div>

        {/* /////////////////// */}
      </div>
    </div>
  );
};

export default LonghaulMaster;
